import { Icon } from '@iconify/react'
import type { CSSProperties } from 'react'
import { getManagerialKpiCriterion } from '../../lib/managerial-kpi-criteria'
import type { ManagerialKpiView } from '../../lib/managerial-kpis'
import { LIVE_MANAGERIAL_KPI_IDS } from '../../lib/managerial-kpis'
import { withPlaceholderTitle } from '../../lib/placeholder-ui'
import { KpiInfoHint } from './KpiInfoHint'
import styles from './KpiCard.module.css'

type KpiCardStyle = CSSProperties & {
  '--kpi-index'?: number
}

interface KpiCardProps {
  item: ManagerialKpiView
  index: number
}

const ICON_TONE_CLASS: Record<ManagerialKpiView['iconTone'], string> = {
  teal: styles.toneTeal,
  green: styles.toneGreen,
  violet: styles.toneViolet,
  pink: styles.tonePink,
  blue: styles.toneBlue,
  purple: styles.tonePurple,
  amber: styles.toneAmber,
  cyan: styles.toneCyan,
}

const VALUE_TONE_CLASS: Record<ManagerialKpiView['valueTone'], string> = {
  growth: styles.valueGrowth,
  brand: styles.valueBrand,
}

export function KpiCard({ item, index }: KpiCardProps) {
  const cardStyle: KpiCardStyle = { '--kpi-index': index }
  const criterion = getManagerialKpiCriterion(item.id)
  const needsDefinition = !LIVE_MANAGERIAL_KPI_IDS.some((id) => id === item.id)

  return (
    <article
      className={styles.card}
      style={cardStyle}
      aria-label={`${item.label}: ${item.formattedValue}`}
      aria-busy={item.isBusy}
    >
      <div className={`${styles.iconWrap} ${ICON_TONE_CLASS[item.iconTone]}`}>
        <Icon icon={item.icon} aria-hidden />
      </div>
      <div className={styles.body}>
        <p
          className={
            item.isPlaceholder ? withPlaceholderTitle(styles.label) : styles.label
          }
        >
          {item.label}
        </p>
        <p className={`${styles.value} ${VALUE_TONE_CLASS[item.valueTone]}`}>
          {item.formattedValue}
        </p>
        {needsDefinition ? (
          <span className={styles.pending}>Aguardando definição</span>
        ) : null}
      </div>
      {criterion ? (
        <KpiInfoHint kpiId={item.id} criterion={criterion} placeAbove={index >= 8} />
      ) : null}
    </article>
  )
}
